export default {
  /*
   * 日期格式化
   * 默认格式：yyyy-MM-dd
   */
  dateFormatter: function (row, column, format) {
    var value = row[column.property]
    value = (typeof value === 'number' ? new Date(value) : value)
    if (value === undefined || value === null || value.getFullYear === undefined) {
      return value
    }
    format = format || 'yyyy-MM-dd'
    // ----↓ 日期格式化方法 ↓----
    // TODO 使用DateUtil.format
    var formatDateToString = function (date, fmt) {
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }
    // ----↑ 日期格式化方法 ↑----
    return formatDateToString(value, format)
  },

  /*
   * 时间格式化
   * 默认格式：yyyy-MM-dd HH:mm:ss
   */
  dateTimeFormatter: function (row, column, format) {
    var value = row[column.property]
    value = (typeof value === 'number' ? new Date(value) : value)
    if (value === undefined || value === null || value.getFullYear === undefined) {
      return value
    }
    format = format || 'yyyy-MM-dd HH:mm:ss'
    // ----↓ 日期格式化方法 ↓----
    // TODO 使用DateUtil.format
    var formatDateToString = function (date, fmt) {
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }
    // ----↑ 日期格式化方法 ↑----
    return formatDateToString(value, format)
  },

  /*
   * 布尔型 格式化
   */
  booleanFormatter: function (row, column, format) {
    var result = null
    if (row[column.property] === true) {
      result = '√'
    } else if (row[column.property] === false) {
      result = '×'
    }
    return result
  }

}



// WEBPACK FOOTER //
// ./src/baize/src/ColumnFormatter.js